import { FC } from 'react';
import CrossMark from 'components/Icons/CrossMark';
import DirectionArrow from 'components/Icons/DirectionArrowAlt';
import { useRouter } from 'next/router';

interface DrawerNavigationProps {
  title: string;
  subTitle?: string;
  onNavigateBack?: () => void;
  onClose: () => void;
  hideBack?: boolean;
}

const DrawerNavigation: FC<DrawerNavigationProps> = ({
  title,
  subTitle,
  onNavigateBack,
  onClose,
  hideBack
}) => {
  const router = useRouter();

  const purposeList: any = {
    'distance': "Single Vision Distance",
    'reading': "Single Vision Reading",
    'multifocal': "Multifocal",
    'bifocal': "Bifocal",
  };

  const getPurposeTitle = () => {
    if (subTitle) {
      if ((router.locale == 'ca' || router.locale == 'nz') && subTitle == 'multifocal') {
        return 'Progressive';
      }

      return purposeList[subTitle];
    }
    return subTitle;
  }

  return (
    <>
      <div className="flex items-center justify-between text-brand-black100">
        {!hideBack && onNavigateBack && (
          <span
            className="cursor-pointer hover:text-brand-orange"
            onClick={onNavigateBack}>
            <DirectionArrow fill="currentColor" />
          </span>
        )}
        <span className="mdx:mb-[2px] mb-[10px] flex-auto px-[6px] text-center text-[32px] font-medium mdx:text-[20px]">
          {title}
        </span>

        <span
          className="cursor-pointer hover:text-brand-orange"
          onClick={onClose}>
          <CrossMark fill="currentColor" />
        </span>
      </div>
      {subTitle && (
        <div className="w-[100%] text-center">
          {getPurposeTitle()}
        </div>
      )}
    </>
  );
};

export default DrawerNavigation;
